import { render, staticRenderFns } from "./TemplateDelegate.vue?vue&type=template&id=ad9fc39c"
import script from "./TemplateDelegate.vue?vue&type=script&lang=js"
export * from "./TemplateDelegate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports